/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext } from "react";
import { TDroppableID } from "./DragAndDropTypes";

export interface IDroppableContext {
	droppableId: TDroppableID;
	draggignOver: boolean;
}

export const DroppableContext = React.createContext<IDroppableContext>(null);

export function useDroppableContext(): IDroppableContext {
	return useContext(DroppableContext);
}
